import { render, staticRenderFns } from "./ZavaFooter.vue?vue&type=template&id=edab843c"
import script from "./ZavaFooter.vue?vue&type=script&lang=js"
export * from "./ZavaFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports